import useJwt from '@/auth/jwt/useJwt';

export const getMyWR1TotalOverView = async data => {
  const result = await useJwt.get('dashboard?objectType=MyWR1TotalOverView', {
    params: {
      search: {
        ...data,
      },
    },
  });
  return result?.data.result;
};

export const getMyWR1TotalQuotationByComp = async data => {
  const result = await useJwt.get(
    'dashboard?objectType=MyWR1TotalQuotationByComp',
    {
      params: {
        search: {
          ...data,
        },
        pageSize: 5,
      },
    }
  );
  return result?.data.result;
};

export const getMyWR1TotalBookingByComp = async data => {
  const result = await useJwt.get(
    'dashboard?objectType=MyWR1TotalBookingByComp',
    {
      params: {
        search: {
          ...data,
        },
        pageSize: 5,
      },
    }
  );
  return result?.data.result;
};

export const getMyWR1TotalRevenueByComp = async data => {
  const result = await useJwt.get(
    'dashboard?objectType=MyWR1TotalRevenueByComp',
    {
      params: {
        search: {
          ...data,
        },
        pageSize: 5,
      },
    }
  );
  return result?.data.result;
};


export const getMyWR1TotalQuotationByServ = async data => {
  const result = await useJwt.get(
    'dashboard?objectType=MyWR1TotalQuotationByServ',
    {
      params: {
        search: {
          ...data,
        },
        pageSize: 5,
      },
    }
  );
  return result?.data.result;
};
export const getMyWR1TotalBookingByServ = async data => {
  const result = await useJwt.get(
    'dashboard?objectType=MyWR1TotalBookingByServ',
    {
      params: {
        search: {
          ...data,
        },
        pageSize: 5,
      },
    }
  );
  return result?.data.result;
};


export const getMyWR1TotalRevenueByServ = async data => {
  const result = await useJwt.get(
    'dashboard?objectType=MyWR1TotalRevenueByServ',
    {
      params: {
        search: {
          ...data,
        },
        pageSize: 5,
      },
    }
  );
  return result?.data.result;
};



export const getMyWR1TotalQuotationBySale = async data => {
  const result = await useJwt.get(
    'dashboard?objectType=MyWR1TotalQuotationBySale',
    {
      params: {
        search: {
          ...data,
        },
        pageSize: 5,
      },
    }
  );
  return result?.data.result;
};
export const getMyWR1TotalBookingBySale = async data => {
  const result = await useJwt.get(
    'dashboard?objectType=MyWR1TotalBookingBySale',
    {
      params: {
        search: {
          ...data,
        },
        pageSize: 5,
      },
    }
  );
  return result?.data.result;
};


export const getMyWR1TotalRevenueBySale = async data => {
  const result = await useJwt.get(
    'dashboard?objectType=MyWR1TotalRevenueBySale',
    {
      params: {
        search: {
          ...data,
        },
        pageSize: 5,
      },
    }
  );
  return result?.data.result;
};


